import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MDBDataTable } from 'mdbreact';
import { CSVLink } from "react-csv";
import dayjs from 'dayjs';
import { DatePicker, Select } from "antd";
import { dateFormat, timeFormat } from "../../../../dynamicController";
import Loading from "../Loading";

const { RangePicker } = DatePicker;

const mySwal = withReactContent(Swal);

const DiscountCodeReportCard = ({ token, outlets }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [startDate, setStartDate] = useState(dayjs().startOf('month'))
    const [endDate, setEndDate] = useState(dayjs().endOf('month'))
    const [outletId, setOutletId] = useState([])
    const [outletOption, setOutletOption] = useState([])

    useEffect(() => {
        if (outlets) {
            let outletList = []
            for (let i = 0; i < outlets.length; i++) {
                let outletObject = {
                    value: outlets[i].id,
                    label: `${outlets[i].outlet_fullname} (${outlets[i].outlet_name})`
                }
                outletList.push(outletObject)
            }
            setOutletOption(outletList)
        }
    }, [outlets])

    useEffect(() => {
        setLoading(true)
        axios
            .post("/api/admin/report/discountCodeReport", { startDate, endDate, outletIds: outletId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setData(res.data.data)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }, [])

    const handleDate = (dates, dateStrings) => {
        if (dates) {
            setStartDate(dateStrings[0])
            setEndDate(dateStrings[1])
        } else {
            setStartDate("")
            setEndDate("")
        }
    };

    const handleReset = () => {
        setStartDate(dayjs().startOf('month'))
        setEndDate(dayjs().endOf('month'))
        setOutletId([])
        setLoading(true)
        axios
            .post("/api/admin/report/discountCodeReport", { startDate: dayjs().startOf('month').format("YYYY-MM-DD"), endDate: dayjs().endOf('month').format("YYYY-MM-DD") }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setData(res.data.data)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    const handleFilter = () => {
        setLoading(true)
        axios
            .post("/api/admin/report/discountCodeReport", { startDate, endDate, outletIds: outletId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setData(res.data.data)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    let tableData = {
        columns: [
            {
                label: t("Date"),
                field: "date",
                sort: "asc"
            },
            {
                label: t("Discount Code"),
                field: "code",
                sort: "asc"
            },
            {
                label: t("Discount Code Type"),
                field: "discount_type",
                sort: "asc"
            },
            {
                label: t("Discount Code Amount"),
                field: "discount_amount",
                sort: "asc"
            },
            {
                label: t("Outlet"),
                field: "outlet",
                sort: "asc"
            },
            {
                label: t("Number of Redemption"),
                field: "total_redeem",
                sort: "asc"
            },
            {
                label: t("Total Discount Amount"),
                field: "total_discount_amount",
                sort: "asc"
            },
        ],
        rows: data
    };

    const csvData = {
        headers: [
            { label: "Date", key: "date" },
            { label: "Discount Code", key: "code" },
            { label: "Discount Code Type", key: "discount_type" },
            { label: "Discount Code Amount", key: "discount_amount" },
            { label: "Outlet", key: "outlet" },
            { label: "Number of Redemption", key: "total_redeem" },
            { label: "Total Discount Amount", key: "total_discount_amount" },
        ],
        data
    };

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="card-title">{t("Discount Code Report")}</h5>
            </div>

            <div className="card-body">
                <div className="mb-5">
                    <h6>{t("Filter")}</h6>

                    <div className="mb-3">
                        <label htmlFor="outletId">{t("Select Outlet")}: </label>
                        <Select
                            mode="multiple"
                            id="outletId"
                            name="outletId"
                            allowClear
                            style={{ width: '100%' }}
                            placeholder={t("Select Outlet")}
                            showSearch
                            optionFilterProp="label"
                            onChange={(value) => setOutletId(value)}
                            options={outletOption}
                            value={outletId}
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="date">{t("Select Transaction Date")}: </label>
                        <RangePicker
                            id="date"
                            name="date"
                            placeholder={[t("Start date"), t("End date")]}
                            onChange={handleDate}
                            style={{ width: '100%' }}
                            value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : []}
                            allowClear={false}
                            presets={[
                                { label: t("Today"), value: [dayjs(), dayjs()] },
                                { label: t("Yesterday"), value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')] },
                                { label: t("Last 7 Days"), value: [dayjs().subtract(6, 'day'), dayjs()] },
                                { label: t("Last 30 Days"), value: [dayjs().subtract(29, 'day'), dayjs()] },
                                { label: t("This Month"), value: [dayjs().startOf('month'), dayjs().endOf('month')] },
                                { label: t("Last Month"), value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] }
                            ]}
                        />
                    </div>

                    <div className="d-flex">
                        <button onClick={() => handleFilter()} className="btn btn-primary btn-inline form-control me-3">
                            {t("Filter")}
                        </button>
                        <button onClick={() => handleReset()} className="btn btn-secondary btn-inline form-control ms-3">
                            {t("Reset")}
                        </button>
                    </div>
                </div>

                <div className="text-center mt-5">
                    {
                        loading ? <Loading /> : (
                            <div>
                                <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename={`discountcode_report_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                        {t("Download Report")}
                                    </CSVLink>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default DiscountCodeReportCard;